import React, { useState, useEffect } from "react";
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";

import AddButton from "@components/Button/AddButton";
import { getAllSensorsBatched } from "@modules/Sensors/services/sensorCrud";
import { getTrees } from "@modules/Trees/services/treeCrud";
import {
  InstallationForm,
  InstallationMessage,
} from "@modules/Trees/components/Form/AddForm/steps/Installation";
import { createScheduledQueryFn, REQUEST_PRIORITIES } from "@helper/requestPriority";

function InstalledSensors({ values, setFieldValue, setOpenSensorForm, addedSensor }) {
  const { t } = useTranslation();
  const scheduledGetAllSensorsBatched = createScheduledQueryFn(
    getAllSensorsBatched,
    REQUEST_PRIORITIES.NORMAL,
    "getAllSensorsBatched"
  );
  const { data: sensors, refetch: refetchSensors } = useQuery(
    "sensors",
    scheduledGetAllSensorsBatched,
    {
      refetchOnWindowFocus: false,
      retry: false,
    }
  );
  const scheduledGetTrees = createScheduledQueryFn(getTrees, REQUEST_PRIORITIES.NORMAL, "getTrees");
  const { data: trees } = useQuery("trees", scheduledGetTrees, {
    refetchOnWindowFocus: false,
    retry: false,
  });
  const normalizedTrees = Array.isArray(trees)
    ? trees
    : Array.isArray(trees?.results)
    ? trees.results
    : [];
  const tree = normalizedTrees.find((tree) => tree.id === values.treeId) || null;
  const [showInstallationForm, setOpenInstallationForm] = useState(false);
  const [installationItem, setInstallationItem] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);
  useEffect(() => {
    refetchSensors();
  }, [addedSensor]);
  const addFields = () => {
    setOpenInstallationForm(true);
  };

  return (
    <>
      <InstallationMessage
        tree={tree}
        setIsUpdate={setIsUpdate}
        setOpenForm={setOpenInstallationForm}
        setInstallationItem={setInstallationItem}
      />
      <AddButton
        label={t("installation")}
        action={() => {
          addFields();
        }}
      />
      {tree && (
        <InstallationForm
          show={showInstallationForm}
          setOpenForm={setOpenInstallationForm}
          setIsUpdate={setIsUpdate}
          isUpdate={isUpdate}
          tId={tree.id}
          setFieldValue={setFieldValue}
          sensors={sensors}
          installationItem={installationItem}
          setInstallationItem={setInstallationItem}
          setOpenSensorForm={setOpenSensorForm}
          addedSensor={addedSensor}
        />
      )}
    </>
  );
}

export default InstalledSensors;
